import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { FontProvider } from '../FontProvider';
import { ReportThemeContainer } from './ReportThemeContainer';
import { MenuItemProviderProvider } from './MenuItemProvider';
const ElementTypeContext = createContext('report');
const ElementTypeProvider = ElementTypeContext.Provider;
export function useElementType() {
    return useContext(ElementTypeContext);
}
export const ReportContainerProviders = (props) => {
    return (_jsx(FontProvider, { children: _jsx(MenuItemProviderProvider, Object.assign({ menuItemProvider: props.menuItemProvider }, { children: _jsx(ReportThemeContainer, Object.assign({ url: props.url, packageUri: props.packageUri, themeOverrides: props.themeOverrides }, { children: _jsx(ElementTypeProvider, Object.assign({ value: props.elementType }, { children: props.children })) })) })) }));
};
